import React, {Component} from 'react'
import {Form, Select, Row, Col, Button, Table, message} from 'antd';
import {listFormItemLayout} from '../../utills/common'
import LinkButton from '../../components/link-button'
import {reqAddresses} from '../../api'
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const AuthLinkButton = authorizeBase(LinkButton)
const {Option} = Select;

const type = {'1': '发货企业', '6': '目的仓库(卸货仓)', '2': '清关仓库(通知方)', '3': '国内仓库联系人'};
class AddrList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        };
    }

    handleSubmit = e => {
        e.preventDefault();
        this.getProducts(1);
    };
    getProducts = async (pageNum) => {
        const pageSize = 10;
        const {getFieldsValue} = this.props.form;
        const values = getFieldsValue();
        values.pageNum = pageNum;
        values.pageSize = pageSize;
        let result = await reqAddresses(values)
        if (result.code === 200) {
            this.setState({
                pageNum: pageNum,
                total: result.data.total,
                list: result.data.rows
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }

    };

    componentDidMount() {
        this.getProducts(1);
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const columns = [
            {
                title: '类型',
                dataIndex: 'type',
                width:'8%',
                render: (text, record, index) => {
                    return type[text];
                }
            },
            {
                title: '公司名称',
                dataIndex: 'company',
                width:'18%',
            },
            {
                title: '联系人',
                dataIndex: 'contact',
                width:'8%',
            },
            {
                title: '地址',
                dataIndex: 'address',
                width:'40%',
                textWrap: 'word-break',
                ellipsis: true,
                render: (text, record) => (
                    <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
                        {text}
                    </div>
                ),
            },
            // {
            //     title: '是否默认',
            //     dataIndex: 'defalutFlag',
            //     width:'7%',
            //     render: (text, record, index) => {
            //         if(text == 'Y'){
            //             return '是';
            //         }
            //         return '';
            //     }
            // },
            {
                title: '关联城市',
                dataIndex: 'relCity',
                width:'7%',
            },
            {
                title: '操作',
                dataIndex: 'opt',
                width:'6%',
                render: (text, record) => (
                    <span><AuthLinkButton authority="address:edit"
                                          onClick={() => this.props.history.push('/addrAdd', {id: record.id})}>编辑</AuthLinkButton></span>
                )
            },
        ];
        return (
            <div>
                <div className='box-shadow margin-bootom'>
                    <br/>
                    <Form {...listFormItemLayout} onSubmit={this.handleSubmit}>
                        <Row>
                            <Col span={6}>
                                <Form.Item label="类型">
                                    {getFieldDecorator('type', {
                                        initialValue: '',
                                    })(<Select>
                                        <Option value="">全部</Option>
                                        <Option value="3">国内仓库联系人</Option>
                                        <Option value="2">清关仓库(通知方)</Option>
                                        <Option value="6">目的仓(卸货仓)</Option>
                                    </Select>)}
                                </Form.Item>
                            </Col>
                            <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                                <Button type='primary' htmlType='submit'
                                        style={{float: 'right', marginRight: '13%'}}>查询</Button>
                                <AuthButton type='primary' style={{float: 'right', marginRight: '20px'}} authority={"address:add"} onClick={e=>{
                                    this.props.history.push('/addrAdd')
                                }}>新增</AuthButton>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow'>
                    <Table columns={columns}  bordered dataSource={this.state.list}
                           rowKey='id'/* scroll={{x: 1300}}*/ size="middle"
                           pagination={{
                               current: this.state.pageNum,
                               total: this.state.total,
                               showQuickJumper: true,
                               onChange: this.getProducts,
                           }}
                    />
                </div>
            </div>
        );
    }
}
const AddrListForm = authorizePage("")(Form.create()(AddrList));
export default AddrListForm